<script setup lang="ts">
import type { Locale } from '@/settings/langs'
import { localeToOgLocale } from '@/settings/langs'

const props = withDefaults(defineProps<Props>(), {
  clientID: siteUtils.isProd ? '108055860030-6bi4udbj1v8pbi2tda2if1pkusc2j7up.apps.googleusercontent.com' : '108055860030-6bi4udbj1v8pbi2tda2if1pkusc2j7up.apps.googleusercontent.com',
  btnText: 'signin_with',
  theme: 'filled_blue',
  size: 'large',
  shape: 'rectangular',
  logoAligment: 'left'
})

declare global {
  interface Window {
    handleGoogleCredentialResponse: (response: google.accounts.id.CredentialResponse) => void
    __googleGsiInitialized: boolean | undefined
  }
}

interface ExtendedIdConfiguration extends google.accounts.id.IdConfiguration {
  ux_mode?: 'popup' | 'redirect'
  login_uri?: string
  locale?: string
}

interface Props {
  clientID?: string
  btnText?: 'signin_with' | 'signup_with'
  theme?: string
  size?: string
  shape?: string
  logoAligment?: string
  callBack: (token: string) => void
}
const route = useRoute()
const effectiveLocale = computed(() =>
  localeToOgLocale[route.params.locale as Locale] ?? 'en_US'
)
const { screens } = tools
function handleGoogleCredentialResponse(response: google.accounts.id.CredentialResponse) {
  props.callBack(response.credential)
}
const isInit = ref(false)
const googleButtonContainer = useTemplateRef('google-button-container')
const scale = ref('')
function initButton() {
  setTimeout(() => {
    const btnWidth = googleButtonContainer.value?.clientWidth || 0
    if (btnWidth) {
      const targetWidth = screens.value.big.alLeast ? 270 : 240
      scale.value = `transform: scale(${(targetWidth / btnWidth).toFixed(1)})`
    }
    isInit.value = true
  }, 800)
}
onMounted(() => {
  window.handleGoogleCredentialResponse = handleGoogleCredentialResponse
  const optionsBtn = {
    theme: props.theme,
    size: props.size,
    text: props.btnText,
    type: 'standard',
    locale: effectiveLocale.value,
    shape: props.shape,
    logo_aligment: props.logoAligment
  }
  const config: ExtendedIdConfiguration = {
    client_id: props.clientID,
    callback: (r: google.accounts.id.CredentialResponse) => window.handleGoogleCredentialResponse(r),
    ux_mode: 'popup',
    auto_prompt: false
  }
  if (!window.google) {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => {
      if (!window.__googleGsiInitialized) {
        window.google.accounts.id.initialize(config)
        window.__googleGsiInitialized = true
      }
      if (googleButtonContainer.value) {
        window.google.accounts.id.renderButton(googleButtonContainer.value, optionsBtn as any)
        initButton()
      }
    }
    document.head.appendChild(script)
  } else {
    if (!window.__googleGsiInitialized) {
      window.google.accounts.id.initialize(config)
      window.__googleGsiInitialized = true
    }
    if (googleButtonContainer.value) {
      window.google.accounts.id.renderButton(googleButtonContainer.value, optionsBtn as any)
      initButton()
    }
  }
})
</script>

<template>
  <div
    :id="btnText"
    ref="google-button-container"
    :key="btnText"
    class="transition-opacity"
    :class="{ 'opacity-0': !isInit }"
    :style="[scale]"
  />
</template>

<style scoped lang="postcss">

</style>
